import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseCellStepper } from '../model';
import { NbDialogService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { SectionBuilderStoreService } from '../../section-builder-store.service';
import { RowCell, GridCell, Section, ContentStatusEnum } from '@urbannex/storethemes';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'kve-product-cell-stepper',
  templateUrl: './product-cell-stepper.component.html',
  styleUrls: ['./product-cell-stepper.component.scss']
})
export class ProductCellStepperComponent extends BaseCellStepper implements OnInit {
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;

  @Output() closeHostDialog = new EventEmitter<void>()
  
  constructor(
    dialogService:NbDialogService,
    ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService
  ){
    super(dialogService,ofbizFormsService,sectionBuilderStoreService,configurationService);
  }
  
  ngOnInit(): void {
    console.log(this.cell);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.contentEnum = this.cell.contentEnum;
    console.log(this.contentEnum)
    this.stepperTitle = this.getStepperTitle(this.contentEnum)
    this.contentElements = this.cell.contentElements;
    this.baseUrl = this.configurationService.getBaseUrl();
  }

  selectProduct(resp){
    console.log(resp);
    const formName = resp["formName"];
    const formLocation = resp["formLocation"];
    const link = resp["link"];
    const parts = link.split('/');
    const productId = parts[parts.length - 1]
    console.log(productId);
    const formData = {formName:formName,formLocation:formLocation}
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ])
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        this.getImageSrc(summary["fields"]);
      })
  }

  onSubmitContent(){
    console.log("onSubmitContent")
    this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
    this.sectionBuilderStoreService.updateSection(this.section);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.closeHostDialog.emit();
  }

}
